import {
    Box,
    Button,
    Hidden,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Theme,
    Typography,
    useTheme,
    Skeleton,
} from "@mui/material";
import TableHeadComponent from "./TableHeadComponent";
import TableBodyComponent from "./TableBodyComponent";
import { CustomTableProps } from "../../types";
import TablePaginationComponent from "./TablePaginationComponent";
import { DropDownIcons } from "../../../../assets/SvgIcons";
import { useEffect, useState } from "react";
import { BottomMenu } from "../BottomMenu";
import { NO_DATA_AVAILABLE } from "../../../../utils/constant";


export default function CustomTable(
    {
        isLoading = false,
        tableBody = <></>,
        tableHeaderData = [],
        tableContainerStyles = {},
        tableHeadRowCustomStyles = {},
        tableHeadFontStyles = {},
        tableBodyCustomStyles = {},
        tableBodyLoaderRowCustomStyles = {},
        isPaginationVisible = true,
        tableDataCount = 0,
        handlePageChange = () => { return; },
        handleRowsPerPageChange = () => { return; },
        handleSort = () => { return; },
        isShowMoreVisible = false,
        handleShowMore = () => { return; },
        loadingRowsNum = 10,
        noResultMsg = NO_DATA_AVAILABLE,
        rowsPerPageOptions = [10, 20, 30],
        rowsPerPage = 10,
        currentPage = 0,
        order = "asc",
        orderBy = "",
        tableData = [],
        manualResponsiveBody = false,
        ManualResponsiveBodyComponent,
        hideResponsiveHeader = false,
        paginationStyles = {},
        headSticky,
        isScrollTable = false
    }: CustomTableProps): JSX.Element {
    const { palette } = useTheme()

    const [tableHeaderMenu, setTableHeaderMenu] = useState<boolean>(false)
    const [tableHeaderKey, setTableHeaderKey] = useState<string>(orderBy || tableHeaderData?.[1]?.key || tableHeaderData?.[1]?.id)

    const style: any = { color: palette.text.secondary, fontWeight: 500, fontSize: '14px', textTransform: 'uppercase', textWrap: 'nowrap', paddingRight: 0, paddingLeft: 0 }

    const handleHeader = () => {
        setTableHeaderMenu(true)
    }




    useEffect(() => {
        if (orderBy && orderBy !== tableHeaderKey) {
            setTableHeaderKey(orderBy)
        }
    }, [orderBy])

    useEffect(() => {
        if (manualResponsiveBody && tableHeaderKey && tableHeaderKey !== orderBy) {
            handleSort(tableHeaderKey, order)
        }
    }, [tableHeaderKey, order])


    return (
        <>
            <Hidden only={'xs'}>
                <TableContainer sx={tableContainerStyles}>
                    <Table sx={{ maxHeight: '100%' }} stickyHeader={headSticky}>
                        <TableHeadComponent
                            isLoading={isLoading}
                            tableHeadRowCustomStyles={tableHeadRowCustomStyles}
                            tableHeadFontStyles={tableHeadFontStyles}
                            tableHeaderData={tableHeaderData}
                            handleSort={handleSort}
                            tableDataCount={tableDataCount}
                            order={order}
                            orderBy={orderBy}
                        />
                        <TableBodyComponent
                            isLoading={isLoading}
                            tableDataCount={tableDataCount}
                            tableBodyCustomStyles={tableBodyCustomStyles}
                            loadingRowsNum={loadingRowsNum}
                            loadingColsNum={tableHeaderData?.length ?? 0}
                            tableBodyLoaderRowCustomStyles={tableBodyLoaderRowCustomStyles}
                            tableBody={tableBody}
                        />
                    </Table>
                    {!isLoading && tableDataCount === 0 && (
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <Typography
                                variant="body_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary
                                })}
                            >
                                {noResultMsg}
                            </Typography>
                        </Box>
                    )}
                </TableContainer>
            </Hidden>
            <Hidden smUp={true}>
                <TableContainer sx={{ maxHeight: { xs: '86%', sm: 'inherit' } }}>
                    <Table sx={{ height: '100%' }}>
                        {!hideResponsiveHeader && (
                            <TableHead>
                                <TableRow>
                                <TableCell align='left' style={{ ...style }}>
                                    {tableHeaderData?.[0]?.label}
                                </TableCell>
                                <TableCell align='center' sx={{
                                    ...style,
                                }}>
                                    <TableSortLabel
                                        onClick={() => handleHeader()}
                                        sx={{}}
                                        // textOverflow: 'ellipsis',
                                        // whiteSpace: 'nowrap',
                                        // overflow: 'hidden',
                                        // maxWidth: '50px'
                                        IconComponent={() => <DropDownIcons style={{ marginRight: '5px' }} />} >
                                        {tableHeaderData?.filter((item) => (item?.id || item?.key) === tableHeaderKey)[0]?.label}
                                    </TableSortLabel>
                                </TableCell>
                                </TableRow>
                            </TableHead>
                        )}
                        {isLoading && manualResponsiveBody && (
                            <TableBody>
                                {[...Array(loadingRowsNum)].map((_, index) => (
                                    <TableRow key={index}>
                                        <TableCell colSpan={2} sx={{ p: 0, borderBottom: 'none' }}>
                                            <Box sx={(theme: Theme) => ({
                                                border: `1px solid ${theme.palette.text.secondary}33`,
                                                borderRadius: '12px',
                                                p: '12px',
                                                backgroundColor: theme.palette.common.white,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1.5,
                                                m: '6px 0',
                                            })}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', columnGap: '12px' }}>
                                                    <Skeleton variant="rectangular" width={22} height={22} sx={{ borderRadius: '4px' }} />
                                                    <Skeleton variant="rectangular" width={35} height={35} sx={{ borderRadius: '8px' }} />
                                                    <Box sx={{ flex: 1 }}>
                                                        <Skeleton variant="text" width="80%" height={20} />
                                                        <Skeleton variant="text" width="60%" height={16} />
                                                    </Box>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', pt: '8px',
                                                    }}
                                                >
                                                    <Box>
                                                        <Skeleton variant="text" width={80} height={12} sx={{ mb: 0.5 }} />
                                                        <Skeleton variant="text" width={60} height={18} />
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Skeleton variant="text" width={110} height={12} sx={{ ml: 'auto', mb: 0.5 }} />
                                                        <Skeleton variant="text" width={80} height={18} sx={{ ml: 'auto' }} />
                                                    </Box>
                                                    <Box>
                                                        <Skeleton variant="text" width={100} height={12} sx={{ mb: 0.5 }} />
                                                        <Skeleton variant="text" width={80} height={18} />
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Skeleton variant="text" width={150} height={12} sx={{ ml: 'auto', mb: 0.5 }} />
                                                        <Skeleton variant="text" width={100} height={18} sx={{ ml: 'auto' }} />
                                                    </Box>
                                                    <Box>
                                                        <Skeleton variant="text" width={60} height={12} sx={{ mb: 0.5 }} />
                                                        <Skeleton variant="text" width={50} height={18} />
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        )}
                        {!manualResponsiveBody &&
                            <TableBody>
                                {!isLoading && tableData?.map((item: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell
                                            style={{ ...style }}
                                            align='left'
                                        >
                                            <Typography
                                                variant="subtitle_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.primary[500],
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    maxWidth: '150px'
                                                })}
                                            >
                                                {item?.[tableHeaderData[0]?.id]}
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            style={{ ...style }}
                                            align='center'
                                        >
                                            <Typography
                                                variant="subtitle_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.text.primary,
                                                })}
                                            >
                                                {(() => {
                                                    const key = tableHeaderKey;
                                                    const getValue = () => key?.includes('.')
                                                        ? item?.[key.split('.')[0]]?.[key.split('.')[1]]
                                                        : item?.[key as keyof typeof item];

                                                    const value = getValue();
                                                    const isReturnKey = ["year1Return", "year2Return", "year3Return", "year5Return", "year10Return", "oneYearReturns", "threeYearReturns", "fiveYearReturns"].includes(key ?? "");

                                                    if (isReturnKey) {
                                                        const num = Number(value);
                                                        return !Number.isNaN(num) ? `${num.toFixed(2)}%` : "0%";
                                                    }

                                                    if (key === "intFundRating" || key === "fundRating") {
                                                        if (typeof value === 'string' && value.trim().toLowerCase() === 'not rated') return 'Not Rated';
                                                        const num = Number(value);
                                                        return !Number.isNaN(num) && num > 0 ? `${Math.floor(num)}` : 'Not Rated';
                                                    }

                                                    return value ?? "-";
                                                })()}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        }
                        {manualResponsiveBody && ManualResponsiveBodyComponent && !isLoading &&
                            ManualResponsiveBodyComponent}
                    </Table>
                    {/* Show noResultMsg in mobile view when tableData is empty and not loading */}
                    {!isLoading && tableData?.length === 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2 }}>
                            <Typography variant="body_600" sx={(theme: Theme) => ({ color: theme.palette.text.primary })}>
                                {noResultMsg}
                            </Typography>
                        </Box>
                    )}
                </TableContainer>

            </Hidden>
            {isPaginationVisible && !isLoading && tableDataCount > 0 && (
                <Box
                    sx={{
                        marginTop: "10px",
                        ...(isScrollTable && paginationStyles)
                    }}
                >
                    <TablePaginationComponent
                        tableDataCount={tableDataCount}
                        handlePageChange={handlePageChange}
                        handleRowsPerPageChange={handleRowsPerPageChange}
                        rowsPerPage={rowsPerPage}
                        rowsPerPageOptions={rowsPerPageOptions}
                        currentPage={currentPage}
                    />
                </Box>
            )}

            {isShowMoreVisible && !isLoading && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "20px"
                    }}
                >
                    <Button
                        variant="text"
                        sx={(theme: Theme) => ({
                            color: theme.palette.primary[500],
                            padding: "8px",
                            ...theme.typography.body_500
                        })}
                        onClick={handleShowMore}
                    >
                        Show More
                    </Button>
                </Box>
            )}

            <BottomMenu open={tableHeaderMenu} close={() => setTableHeaderMenu(false)} list={tableHeaderData} setTableHeaderKey={setTableHeaderKey} />
        </>
    )
}